import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientLegalHeadFirstHeadSaveIdentityDocumentStepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClientLegalHeadFirstHeadEntity } from './helpers';

export const useLegalClientLegalHeadFirstHeadSaveIdentityDocument = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientLegalHeadFirstHeadSaveIdentityDocumentStepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientLegalHeadFirstHeadSaveIdentityDocumentStep
      ? parseLegalClientLegalHeadFirstHeadEntity(
          data.legalClientLegalHeadFirstHeadSaveIdentityDocumentStep
        )
      : undefined,
    loading,
    error,
    saveIdentityDocument: useCallback(
      async (
        id: string,
        legalHeadId: string,
        firstHeadId: string,
        fileIds: string[]
      ) => {
        const res = await handle({
          variables: {
            id,
            legalHeadId,
            firstHeadId,
            input: { fileIds },
          },
        });
        return res?.data?.legalClientLegalHeadFirstHeadSaveIdentityDocumentStep
          ? parseLegalClientLegalHeadFirstHeadEntity(
              res.data.legalClientLegalHeadFirstHeadSaveIdentityDocumentStep
            )
          : undefined;
      },
      [handle]
    ),
  };
};
